import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13.446 2.6l7.955 7.954a2.045 2.045 0 0 1 0 2.892l-7.955 7.955a2.045 2.045 0 0 1 -2.892 0l-7.955 -7.955a2.045 2.045 0 0 1 0 -2.892l7.955 -7.955a2.045 2.045 0 0 1 2.892 0","key":"svg-0"}],["path",{"d":"M12 8.5v7","key":"svg-1"}],["path",{"d":"M9 10l6 4","key":"svg-2"}],["path",{"d":"M9 14l6 -4","key":"svg-3"}]]

const IconSquareRotatedAsterisk = createReactComponent('outline', 'square-rotated-asterisk', 'SquareRotatedAsterisk', __iconNode);

export default IconSquareRotatedAsterisk;